import React, { useEffect, useState } from "react";
import {
	Avatar,
	Button,
	Card,
	CardBody,
	Input,
	Image,
	Autocomplete,
	AutocompleteItem,
	Tabs,
	Table,
	Tab,
	TableColumn,
	TableHeader,
	TableBody,
	TableRow,
	TableCell,
	Chip,
	Modal,
	ModalHeader,
	ModalBody,
	ModalContent,
	ModalFooter,
	addToast,
} from "@heroui/react";
import BVPlayer from "../components/BVPlayer";
import axios from "axios";
import { eventBus } from "../App";
import { createPortal } from "react-dom";
const formatTime = (seconds) => {
	const total = Math.max(0, Math.floor(seconds || 0));
	const hrs = String(Math.floor(total / 3600)).padStart(2, "0");
	const mins = String(Math.floor((total % 3600) / 60)).padStart(2, "0");
	const secs = String(total % 60).padStart(2, "0");
	return `${hrs}:${mins}:${secs}`;
};
function SubtitlePage(props) {
	const [items, setItems] = React.useState([]);
	const [currentIndex, setCurrentIndex] = React.useState(0);

	const [keywords, setKeywords] = React.useState("");

	const keywordRef = React.useRef("");

	const [loading, setLoading] = useState(false);
	const [hasMore, setHasMore] = useState(true);

	const [currentLiver, setCurrentLiver] = React.useState(0);

	const [searchItems, setSearchItems] = React.useState([]);

	const [searchKeyword, setSearchKeyword] = React.useState("");

	const isFirstRender = React.useRef(true);

	const itemsRef = React.useRef(items);

	const listRef = React.createRef();

	const playerRef = React.createRef();
	useEffect(() => {
		itemsRef.current = items;
	}, [items]);

	useEffect(() => {
		if (items.length === 0) {
			return;
		}
		setTimeout(
			() => {
				items[currentIndex].subtitle.forEach((subtitle) => {
					keywordRef.current.split(",").forEach((keyword) => {
						if (subtitle.content.includes(keyword)) {
							var target = listRef.current.querySelector(
								`.${hash(subtitle.content)}`,
							);
							target.scrollIntoView({
								behavior: "smooth",
								block: "center",
							});
						}
					});
				});
			},
			isMobile() ? 200 : 0,
		);
	}, [currentIndex]);

	const doSearch = (kw, liver, append = false) => {
		keywordRef.current = kw;
		setLoading(true);

		let url = "/api/subtitle/search?keyword=" + kw + "&uid=" + liver;
		if (append) {
			const curItems = itemsRef.current;
			if (curItems.length === 0) {
				setLoading(false);
				return;
			}
			url += "&offset=" + curItems[curItems.length - 1].c_id;
		}

		axios.get(url).then((res) => {
			if (append) {
				setItems((prev) => [...prev, ...(res.data.items ?? [])]);
				setLoading(false);
				setHasMore(res.data.has_more);
			} else {
				setItems([]);
				setHasMore(res.data.has_more);
				setLoading(false);
				setTimeout(() => {
					setItems(res.data.items ?? []);
					setCurrentIndex(0);
				}, 200);
				if (!res.data.items) {
					addToast({
						title: "没有数据喵",
						color: "danger",
					});
				}
			}
		});
	};

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
			return;
		}
		doSearch(keywords, currentLiver);
	}, [currentLiver]);

	const handleScroll = (e) => {
		const { scrollTop, clientHeight, scrollHeight } = e.currentTarget;

		const isBottom = scrollHeight - scrollTop - clientHeight < 50;

		if (isBottom && !loading && hasMore) {
			doSearch(keywords, currentLiver, true);
		}
	};

	useEffect(() => {
		axios
			.get("/api/subtitle/users?keyword=" + searchKeyword)
			.then((res) => {
				setSearchItems(res.data.items ?? []);
			});
	}, [searchKeyword]);

	const [open, setOpen] = React.useState(false);

	return (
		<div className={"w-full h-full flex flex-col overflow-hidden"}>
			<Modal
				isOpen={open}
				onOpenChange={(e) => {
					setOpen(false);
				}}
				scrollBehavior={"inside"}
			>
				<ModalContent>
					<ModalHeader>预览</ModalHeader>
					<ModalBody>
						{items[currentIndex] && (
							<div
								className={
									"flex flex-col  max-h-[360px] overflow-scroll"
								}
								ref={listRef}
							>
								{items[currentIndex].subtitle.map(
									(item, index) => {
										return (
											<div
												key={index}
												onClick={() => {
													playerRef.current.video.currentTime =
														Math.floor(item.from);
												}}
												className={`group flex items-start gap-3 px-3 py-2 rounded-md text-sm transition-colors duration-150 cursor-pointer select-none ${
													contains(
														keywords,
														item.content,
													)
														? "bg-[#CCE3FD] text-[#006FEE] font-medium border-l-2  pl-2.5"
														: "text-[#18181B] hover:bg-[#F4F4F5] hover:text-[#18181B]"
												} ${hash(item.content)}`}
											>
												<span
													className={`shrink-0 font-mono text-xs tabular-nums px-1.5 py-0.5 rounded transition-colors ${"text-[#18181B] group-hover:text-[#52525B]"}`}
												>
													{formatTime(item.from)}
												</span>
												<span className="flex-1 leading-relaxed break-words">
													{item.content}
												</span>
											</div>
										);
									},
								)}
							</div>
						)}
						{items[currentIndex] && (
							<div className="w-full aspect-video min-h-[200px]">
								<BVPlayer
									ref={playerRef}
									bv={av2bv(items[currentIndex].a_id)}
									cid={items[currentIndex].c_id}
									onTimeUpdate={(e) => {}}
									initialTime={Math.max(
										0,
										Math.floor(
											items[currentIndex].subtitle?.find(
												(e) =>
													e.content.includes(
														keywordRef.current,
													),
											)?.from ?? 4,
										) - 4,
									)}
								/>
							</div>
						)}
					</ModalBody>
					<ModalFooter>
						<Button
							onClick={() => setOpen(false)}
							color="danger"
							variant="light"
						>
							关闭
						</Button>
						<Button
							onClick={() => {
								window.open(
									`bilibili://video/${
										items[currentIndex].a_id
									}?start_time=${Math.max(
										0,
										Math.floor(
											items[currentIndex].subtitle?.find(
												(e) =>
													e.content.includes(
														keywordRef.current,
													),
											)?.from ?? 4,
										) - 4,
									)}`,
								);
							}}
							variant="light"
						>
							<img
								src={`https://www.bilibili.com/favicon.ico`}
								className={"w-4 h-4"}
							/>
							<p>在哔哩哔哩打开</p>
						</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>
			<Tabs
				className={"w-full shrink-0"}
				classNames={{
					base: "w-full shrink-0",
					panel: "flex-1 w-full min-h-0 flex flex-col p-0 pt-2 overflow-hidden",
				}}
				fullWidth={isMobile()}
				destroyInactiveTabPanel={false}
			>
				<Tab key={"search"} title={"关键词搜索"}>
					<div
						className={
							"flex flex-row items-center w-full sm:h-12 flex-wrap mb-1.5 shrink-0"
						}
					>
						<Autocomplete
							className="sm:max-w-[12rem] mr-2 max-w-xs mb-2 sm:mb-0"
							items={searchItems}
							labelPlacement="inside"
							placeholder="Liver"
							label={"Liver"}
							onInputChange={(e) => {
								console.log(e);
								setSearchKeyword(e);
							}}
							onClear={() => {
								setCurrentLiver(0);
							}}
							onSelectionChange={(key) => {
								setCurrentLiver(key);
							}}
						>
							{(user) => (
								<AutocompleteItem
									key={user.uid}
									textValue={user.u_name}
								>
									<div className="flex gap-2 items-center">
										<Avatar
											alt={user.u_name}
											className="shrink-0"
											size="sm"
											src={`${AVATAR_API}${user.uid}`}
										/>
										<div className="flex flex-col">
											<span className="text-small">
												{user.u_name}
											</span>
										</div>
									</div>
								</AutocompleteItem>
							)}
						</Autocomplete>
						<div className={"flex items-center"}>
							<Input
								label={"关键词"}
								className={"max-w-xs mr-1.5 "}
								onValueChange={(e) => {
									setKeywords(e);
								}}
								value={keywords}
							></Input>
							<Button
								onClick={(e) => {
									doSearch(keywords, currentLiver);
								}}
								disabled={loading}
							>
								搜索
							</Button>
						</div>
					</div>
					<div
						className={
							"flex flex-row w-full flex-1 min-h-0 sm:gap-4"
						}
					>
						<div
							className={"w-full sm:w-1/2 h-full overflow-y-auto"}
							onScroll={handleScroll}
						>
							{items.map((item, index) => {
								return (
									<div
										key={item.c_id ?? index}
										className={"cursor-pointer mt-2.5"}
										onClick={() => {
											setCurrentIndex(index);
											if (isMobile()) {
												setOpen(true);
											}
										}}
									>
										<Card>
											<CardBody>
												<div className={""}>
													<p className={"font-bold"}>
														{item.title}
													</p>
													<p
														className={
															"mt-1.5 text-gray-500"
														}
													>
														{new Date(
															item.created_at,
														).toLocaleString()}
														<Chip
															className={"ml-2"}
															onClick={() => {
																var t =
																	Math.max(
																		0,
																		Math.floor(
																			items[
																				currentIndex
																			].subtitle?.find(
																				(
																					e,
																				) =>
																					e.content.includes(
																						keywordRef.current,
																					),
																			)
																				?.from ??
																				4,
																		) - 4,
																	);
																if (
																	isMobile()
																) {
																	window.open(
																		`bilibili://video/${
																			items[
																				currentIndex
																			]
																				.a_id
																		}?start_time=${t}`,
																	);
																} else {
																	window.open(
																		`https://www.bilibili.com/video/av${
																			items[
																				currentIndex
																			]
																				.a_id
																		}?t=${t}`,
																	);
																}
															}}
														>
															<p>
																{av2bv(
																	item.a_id,
																)}
															</p>
														</Chip>
													</p>
													<div
														className={
															"flex flex-row items-center mt-1.5"
														}
													>
														<Avatar
															src={`${AVATAR_API}${item.u_id}`}
														></Avatar>
														<p className={"ml-2"}>
															{item.u_name}
														</p>
													</div>
													<Image
														src={
															item.cover +
															"@.avif"
														}
														className={"mt-2"}
													></Image>
												</div>
											</CardBody>
										</Card>
									</div>
								);
							})}
						</div>
						<div
							className={
								"w-full sm:w-1/2 h-full sm:flex flex-col hidden overflow-hidden"
							}
						>
							{items[currentIndex] && (
								<div
									className={
										"flex flex-col max-h-[360px] overflow-y-auto shrink-0 mb-3"
									}
									ref={listRef}
								>
									{items[currentIndex].subtitle.map(
										(item, index) => {
											return (
												<div
													key={index}
													onClick={() => {
														playerRef.current.video.currentTime =
															Math.floor(
																item.from,
															);
													}}
													className={`group flex items-start gap-3 px-3 py-2 rounded-md text-sm transition-colors duration-150 cursor-pointer select-none ${
														contains(
															keywords,
															item.content,
														)
															? "bg-[#CCE3FD] text-[#006FEE] font-medium border-l-2  pl-2.5"
															: "text-[#18181B] hover:bg-[#F4F4F5] hover:text-[#18181B]"
													} ${hash(item.content)}`}
												>
													<span
														className={`shrink-0 font-mono text-xs tabular-nums px-1.5 py-0.5 rounded transition-colors ${"text-[#18181B] group-hover:text-[#52525B]"}`}
													>
														{formatTime(item.from)}
													</span>
													<span className="flex-1 leading-relaxed break-words">
														{item.content}
													</span>
												</div>
											);
										},
									)}
								</div>
							)}
							{items[currentIndex] && (
								<div className="w-full flex-1 min-h-0 overflow-hidden rounded-lg">
									<BVPlayer
										ref={playerRef}
										bv={av2bv(items[currentIndex].a_id)}
										cid={items[currentIndex].c_id}
										onTimeUpdate={(e) => {}}
										initialTime={Math.max(
											0,
											Math.floor(
												items[
													currentIndex
												].subtitle?.find((e) =>
													e.content.includes(
														keywordRef.current,
													),
												)?.from ?? 4,
											) - 4,
										)}
									/>
								</div>
							)}
						</div>
					</div>
				</Tab>
				<Tab key={"livers"} title={"添加主播"}>
					<LiverListFragment />
				</Tab>
			</Tabs>
		</div>
	);
}

function LiverListFragment() {
	const [items, setItems] = React.useState([]);
	useEffect(() => {
		axios.get("/api/subtitle_srv/users/list").then((res) => {
			setItems(res.data.items);
		});
	}, []);

	const [open, setOpen] = React.useState(false);
	const columns = [
		{
			key: "liver",
			label: "LIVER",
		},
		{
			key: "stat",
			label: "STAT",
		},
	];
	const [inputValue, setInputValue] = React.useState("");
	return (
		<div className="h-full overflow-y-auto pb-16">
			<Modal
				isOpen={open}
				onOpenChange={() => {
					setOpen(false);
				}}
			>
				<ModalContent>
					<ModalHeader>添加录播合集</ModalHeader>
					<ModalBody>
						<Input
							label={"合集链接"}
							value={inputValue}
							onValueChange={setInputValue}
						></Input>
					</ModalBody>
					<ModalFooter>
						<Button
							color="danger"
							variant="light"
							onPress={() => {
								setOpen(false);
							}}
						>
							关闭
						</Button>
						<Button
							color="primary"
							onPress={() => {
								var nums = [];
								const cleanInput = (inputValue || "").split(
									"?",
								)[0];
								cleanInput.split("/").forEach((item) => {
									const n = Number(item);
									if (
										item !== null &&
										item !== "" &&
										Number.isInteger(n)
									) {
										nums.push(item);
									}
								});
								if (nums.length < 2) {
									addToast({
										color: "danger",
										title: "链接不正确",
									});
								} else {
									axios
										.post(
											"/api/subtitle_srv/users/add?uid=" +
												nums[0] +
												"&fid=" +
												nums[1],
										)
										.then((res) => {
											addToast({
												color: "success",
												title: "添加成功",
											});
											setTimeout(() => {
												axios
													.get(
														"/api/subtitle_srv/users/list",
													)
													.then((res) => {
														setItems(
															res.data.items,
														);
													});
											}, 200);
											setOpen(false);
											setInputValue("");
										})
										.catch((err) => {
											console.log(err);
										});
								}
							}}
						>
							提交
						</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>
			<Table aria-label="Example table with dynamic content">
				<TableHeader columns={columns}>
					{(column) => (
						<TableColumn key={column.key}>
							{column.label}
						</TableColumn>
					)}
				</TableHeader>
				<TableBody items={items}>
					{(item) => (
						<TableRow key={item.uid}>
							<TableCell className={"flex flex-row items-center"}>
								<Avatar src={`${AVATAR_API}${item.uid}`} />
								<p className={"ml-1.5"}>{item.uname}</p>
							</TableCell>
							<TableCell>
								<Chip variant={"flat"} color={"success"}>
									{item.collection_id[0].status}
								</Chip>
							</TableCell>
						</TableRow>
					)}
				</TableBody>
			</Table>
			{createPortal(
				<div className="fixed right-[3vw] sm:bottom-[6vw]  bottom-[18vw] z-50 flex flex-col">
					<Button
						isIconOnly
						startContent={
							<svg
								xmlns="http://www.w3.org/2000/svg"
								height="24px"
								viewBox="0 -960 960 960"
								width="24px"
								fill="#1f1f1f"
							>
								<path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z" />
							</svg>
						}
						onClick={() => {
							setOpen(true);
						}}
					/>
				</div>,
				document.body,
			)}
		</div>
	);
}

function hash(text, prefix = "sec-") {
	let hash = 2166136261;
	for (let i = 0; i < text.length; i++) {
		hash ^= text.charCodeAt(i);
		hash +=
			(hash << 1) +
			(hash << 4) +
			(hash << 7) +
			(hash << 8) +
			(hash << 24);
	}

	const hashHex = (hash >>> 0).toString(16).padStart(8, "0");

	return `${prefix}${hashHex}`;
}
const magicStr = "FcwAPNKTMug3GV5Lj7EJnHpWsx4tb8haYeviqBz6rkCy12mUSDQX9RdoZf";
const table = {};
for (let i = 0; i < magicStr.length; i++) table[magicStr[i]] = BigInt(i);
let s = [0, 1, 2, 9, 7, 5, 6, 4, 8, 3, 10, 11];
const BASE = 58n,
	MAX = 1n << 51n,
	LEN = 12;
const XOR = 23442827791579n,
	MASK = 2251799813685247n;

function av2bv(src) {
	if (typeof src !== "bigint") src = BigInt(src);
	let r = Array.from("BV1         ");
	let it = LEN - 1;
	let tmp = (src | MAX) ^ XOR;
	while (tmp !== 0n) {
		r[s[it]] = magicStr[Number(tmp % BASE)];
		tmp /= BASE;
		it--;
	}
	return r.join("");
}

function bv2av(src) {
	let r = 0n;
	for (let i = 3; i < LEN; i++) {
		r = r * BASE + BigInt(table[src[s[i]]]);
	}
	return (r & MASK) ^ XOR;
}
function contains(keyword, text) {
	var valid = true;
	keyword.split(",").forEach((item) => {
		if (!text.includes(item)) {
			valid = false;
		}
	});
	return valid;
}

export default SubtitlePage;
